// 9fbef606107a605d69c0edbcd8029e5d
export const ACCOUNT_OVERVIEW = 'account.accountOverview';

const labelsObj = {
  account: {
    accountOverview: {
      referred: [
        {
          name: 'overviewRewardsPointsBannerPLCC',
          contentId: 'b18e0732-a5c6-43c0-a3be-8b75b87e51ee',
          __typename: 'ReferredContent',
        },
        {
          name: 'overviewRewardsPointsBannerMPR',
          contentId: '10c9d9a4-1c90-4150-96ad-80aaca88baaa',
          __typename: 'ReferredContent',
        },
      ],
      lbl_overview_heading: 'ACCOUNT OVERVIEW',
      lbl_overview_addressBookHeading: 'Address Book',
      lbl_overview_addressBookCTA: 'VIEW ADDRESS BOOK',
      lbl_overview_paymentHeading: 'Payment & Gift Cards',
      lbl_overview_paymentCTA: 'VIEW PAYMENT & GIFT CARDS',
      lbl_overview_myPlaceRewardsHeading: 'My Place Rewards',
      lbl_overview_myPlaceRewardsCTA: 'VIEW ALL REWARDS',
      lbl_overview_myFavoritesHeading: 'Favorites',
      lbl_overview_earnPointsHeading: 'Earn Extra Points',
      lbl_overview_ordersHeading: 'Orders',
      lbl_overview_profileInformationHeading: 'Profile Information',
      lbl_overview_myPreferencesHeading: 'Preferences',
      lbl_overview_myPlaceRewardsCardHeading: 'My Place Rewards Credit Card',
      lbl_overview_addressNotAdded: 'Add an address for faster checkout.',
      lbl_overview_defaultBillingAddress: 'Default Billing Address',
      lbl_overview_defaultShipingAddress: 'Default Shipping Address',
      ACC_LBL_MY_REWARDS_HEADING: 'My Rewards',
      lbl_my_rewards_current_points: 'Current Points',
      lbl_my_rewards_next_reward: 'Points to Next Reward',
      lbl_overview_greeting: 'Hi,',
      lbl_overview_addressBookAdd: 'Add',
      lbl_overview_venmo: 'Venmo',
      lbl_overview_giftCard: 'Gift Card(s)',
      lbl_overview_default_creditCard: 'Default Credit Card',
      lbl_overview_card_ending: 'ending in',
      lbl_overview_expires: 'expires',
      lbl_overview_remaining_balance: 'Remaining balance',
      lbl_overview_view_payments: 'View Payment & Gift Cards',
      lbl_overview_add_creditCard: 'Add a credit card for faster checkout.',
      lbl_overview_add_giftCard: 'Add a gift card for faster checkout.',
      lbl_overview_manage_creditCard: 'Manage Credit Account',
      lbl_overview_purchase_giftCards: 'Purchase Gift Cards',
      lbl_overview_refer_friend: 'Refer a Friend',
      lbl_overview_app_settings: 'App Settings',
      lbl_overview_help: 'Help',
      lbl_overview_messages: 'Messages',
      lbl_overview_logout: 'Log Out',
      lbl_overview_myPlaceRewardsAvailable: 'You have {0} available rewards.',
      lbl_overview_myPlaceRewardsUseBy: 'Use by',
      lbl_overview_myPlaceRewardsBonusPointsDay: 'BONUS POINTS DAY',
      lbl_overview_myPlaceRewardsBonusDayLeft: 'You have {0} day left.',
      lbl_overview_myPlaceRewardsDesc: 'Start Shopping to earn points!',
      lbl_overview_myPlaceRewardsCouponType: 'REWARD',
      lbl_overview_check_balance: 'Check Balance',
      lbl_overview_couponTypePlacecash: 'PLACE BUCKS',
      lbl_overview_couponTypeReward: 'REWARD',
      lbl_overview_couponTypeSaving: 'SAVINGS',
      lbl_overview_couponUseBy: 'Use by',
      lbl_overview_couponValid: 'Valid',
      lbl_overview_logout_heading_Text_1: 'Members get more!',
      lbl_overview_join_text: 'JOIN',
      lbl_overview_myWalletHeading: 'Wallet',
      lbl_overview_viewMyWalletCTA: 'VIEW MY WALLET',
      lbl_overview_walletViewAllCTA: 'VIEW ALL',
      lbl_overview_myWalletNoOfferAvailable: 'There are no available rewards or offers.',
      lbl_overview_myWalletStartShop: 'Start shopping to earn points!',
      lbl_overview_myWalletOfferAvailable: 'You have {0} available rewards and offers.',
      lbl_overview_profileInfoMailingAddress: 'Mailing Address',
      lbl_overview_profileInfoMember: 'Member #',
      lbl_overview_profileInfoViewCTA: 'VIEW PROFILE',
      lbl_overview_profileInfoChangeCTA: 'Change',
      lbl_overview_trackYourOrder: 'Track Your Order',
      lbl_overview_manageYourCard: 'MANAGE YOUR CARD',
      lbl_overview_applyOrAcceptOffer: 'APPLY OR ACCEPT OFFER',
      lbl_overview_25Off: '25% OFF',
      lbl_overview_yourKidsBirthdays: ' your kids’ birthdays!',
      lbl_overview_earnDoublePoints: 'EARN DOUBLE POINTS',
      lbl_overview_whenYouCheckout: ' when you check out using your card',
      lbl_overview_exclusiveBonusEvents: 'EXCLUSIVE BONUS EVENTS',
      lbl_overview_tripePointsDoubleRewards: 'Triple points, double rewards & more!',
      lbl_overview_addYourCardTo: 'Add your card to:',
      lbl_overview_addYourCardToPoint2: 'Get 25% off birthday savings',
      lbl_overview_addYourCardToPoint3: 'Check out even faster!',
      lbl_overview_addYourCard: 'ADD YOUR CARD',
      lbl_overview_dontHaveMyPlaceCard: 'Don’t have a My Place Rewards Credit Card?',
      lbl_overview_show_account_number: 'Show My Account Number',
      lbl_overview_hide_account_number: 'Hide My Account Number',
      lbl_overview_add_to_apple_wallet: 'ADD TO APPLE WALLET',
      lbl_overview_add_to_google_pay: 'ADD TO GOOGLE PAY',
      lbl_overview_copyrightTxt: "© 2022 The Children's Place",
      lbl_overview_app_settings_title: 'APP SETTINGS',
      lbl_overview_touch_id: 'Touch ID',
      lbl_overview_face_id: 'Face ID',
      lbl_overview_stay_signed_in: 'Stay Signed In',
      lbl_overview_push_notifications: 'Push Notifications',
      lbl_overview_about: 'About',
      lbl_overview_app_version: 'Version ',
      lbl_overview_enter_password: 'Please re-enter your password',
      lbl_overview_enter_correct_password: 'Please enter correct password',
      lbl_overview_error_heading: 'Error',
      lbl_header_storeDefaultTitle: 'FIND A STORE',
      lbl_overview_message_screen_title: 'Messages',
      lbl_overview_message_days: 'd',
      lbl_overview_walletPage: 'https://mp.vibescm.com/c/76cmsb?data[loyalty_id]=',
      lbl_overview_managePlaceCardPage: 'https://d.comenity.net/childrensplace/?ecid=manageacct',
      lbl_overview_previewlbl: 'Preview testing',
      lbl_overview_chat_now: 'CHAT NOW',
      lbl_header_text: 'cancel',
      lbl_overview_memberIdHeading: 'Member ID',
      lbl_overview_quickLinks: 'Quick Links',
      lbl_overview_myStore: 'My Store',
      lbl_overview_memberSince: 'Member Since',
      lbl_overview_lifetimeSavings: 'Lifetime Savings',
      lbl_overview_viewDashboard: 'View Dashboard',
      lbl_overview_showMemberID: 'Show Member ID',
      lbl_rewardPoints_earningAwayText: 'away from earning your next',
      lbl_rewardPoints_rewardsAvailable: 'Rewards Available',
      lbl_overview_headerMyFavorite: 'My Wishlists',
      lbl_overview_myPlaceRewardsText: 'MY PLACE REWARDS',
      lbl_overview_save30Text: 'SAVE #plccOfferPercentage#',
      lbl_overview_todayText: 'TODAY!',
      lbl_overview_whenToOpenAndUseText: 'when you open & use the',
      lbl_overview_onYourFirstPurchaseText: 'on your first purchase',
      lbl_overview_manageMyCardText: 'Manage My Card',
      lbl_overview_applyNowText: 'Apply Now',
      lbl_overview_myDashboard: 'My Dashboard',
      lbl_overview_perkDashboard: 'Perk Dashboard',
      lbl_overview_rewardDashboard: 'Rewards Dashboard',
      lbl_overview_memberId: 'Member ID',
      lbl_overview_creditCard: 'Credit Card',
      lbl_placeperk_earn: 'Perks you can Earn!',
      lbl_placeperk_works: 'How Does My Place Rewards Status Work?',
      lbl_placeperk_redeemed_perks: 'Redeemed Benefits',
      lbl_placeperk_expired_perks: 'Expired Benefits',
      lbl_placeperk_earned: 'Earned',
      lbl_placeperk_expired: 'Expired',
      lbl_placeperk_redeemed: 'Redeemed',
      lbl_place_perk_bag_banner_status: 'STATUS: Almost a',
      lbl_perks: 'perks',
      test_translations: 'hello december',
      test_translations1: 'hello this is december',
      lbl_place_perk_banner_unlock: "You'll unlock a new",
      lbl_place_perk_banner_order_ship: 'Status when your order ships.',
      lbl_place_perk_remove: 'Remove',
      lbl_perk: 'PERK',
      lbl_placeperk_what_is_pp_des_app:
        '<style>p{font-size:14px; font-family: Nunito;text-align: center; font-weight: 400;}</style><p>Reach for the My Place Rewards stars – a fun way to earn even more benefits!</p>',
      lbl_placeperk_how_it_work_des_app:
        "<style>p{font-size:14px; font-family: Nunito;text-align: center; font-weight: 400;}</style><p>As you spend throughout the year, your status increases to unlock bonus rewards, special perks & offers. The more you spend, the more you get!</p> <p>With every status level reached (go you!), we'll add benefits directly to your account (score!). The best part? You get to reach for the stars every year when your status resets.</p>",
      lbl_perk_status_always_applied: 'Always Applied',
      lbl_perk_status_applied: 'Applied',
      lbl_placeperk_basestar: 'Star',
      lbl_placeperk_benefit: 'Benefit',
      lbl_placeperk_reach_for_stars: 'Reach For The Stars',
      lbl_placeperk_megastar_congrats:
        'YAY! You officially reached the stars – our highest status!',
      lbl_placeperk_spent: 'Spent',
      lbl_placeperk_mystatus_header: 'MY STATUS',
      lbl_placeperk_plcc_megastar_text:
        'Cardholders get instant Megastar benefits & unlock $30 Status Rewards as they spend throughout the year.',
      lbl_placeperk_plcc_next_reward: 'your next $30 Status Reward.',
      lbl_placeperk_plcc_megastar_congrats:
        "YAY! You've officially unlocked all your Status Rewards.",
      lbl_placeperk_no_perk: 'No Perk',
      lbl_placeperk_congrats_short: 'CONGRATS',
      lbl_place_perk_bag_banner: 'Spend #spendLeftForNextPerk# more to unlock your perks!',
      lbl_placeperk_start_earn: 'Start shopping',
      lbl_placeperk_full_details: 'Full Details',
      lbl_placeperk_my_perk: 'My Recent Benefits',
      lbl_placeperk_unlocked: "Benefits You've Unlocked!",
      lbl_placeperk_to_unlock: 'to unlock ',
      lbl_placeperk_view_dashboard: 'My Status Dashboard',
      lbl_placeperk_level: 'Perk Level',
      lbl_placeperk_perk_unlock: 'Unlock even more benefits!',
      lbl_placeperk_total_spend: 'Total Spend',
      lbl_placeperk_header: 'My Place Rewards Status',
      lbl_placeperk_rockstar: 'Rockstar',
      lbl_placeperk_superstar: 'Superstar',
      lbl_placeperk_megastar: 'Megastar',
      lbl_placeperk_congrats: 'CONGRATULATIONS!',
      lbl_placeperk_what_is_pp: 'What is Place Perks?',
      lbl_placeperk_what_is_pp_des:
        'Reach for the My Place Rewards stars – a fun way to earn even more benefits!',
      lbl_placeperk_how_it_work: 'Here’s How It Works!',
      lbl_placeperk_how_it_work_des:
        'As you spend throughout the year, your status increases to unlock bonus rewards, special perks & offers. The more you spend, the more you get!',
      lbl_overview_spend: 'Spend $',
      lbl_overview_to_reach: 'to reach',
      lbl_overview_untill_your_next: 'until your next',
      lbl_placeperk_level_not_reached: 'Perk level not yet reached',
      lbl_placeperk_status: 'status',
      lbl_placeperk_you_unlocked: 'You unlocked',
      lbl_locked_status: 'LOCKED',
      lbl_placeperk_plcc_your_next_reward: 'your next',
      lbl_placeperk_plcc_status_reward: 'Status Reward.',
      lbl_bonus_points_error: 'You have reached the max limit to apply Bonus Points Day Coupon',
      lbl_bonus_points_black_out_day_warning: 'Bonus points unavailable on',
      lbl_bonus_points_heading: 'BONUS POINTS BENEFITS',
      lbl_bonus_points_second_header_label: 'POINTS',
      lbl_placeperk_current_status_benefit: 'Your Current Benefits',
    },
  },
};

export default labelsObj;
